"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xvantageColorPalette = void 0;
var _colorOptions = require("../colorOptions");
var xvantageColorPalette = exports.xvantageColorPalette = {
  navBackground: _colorOptions.imColors.gray50,
  navBackgroundSelected: _colorOptions.imColors.gray100,
  navIndicator: _colorOptions.imColors.primary600,
  onNavBackground: _colorOptions.imColors.gray700,
  onNavBackgroundSelected: _colorOptions.imColors.gray700,
  primary: _colorOptions.imColors.primary600,
  surfaceContainerLow: _colorOptions.imColors.gray25
};